import { render, staticRenderFns } from "./TedsLauncherMenu.vue?vue&type=template&id=8e8050fa&"
import script from "./TedsLauncherMenu.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports